// Generated by ts-to-zod
import { z } from 'zod';

export const getSecretsKeysResponseSchema = z.array(z.string());
